// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stationTable .ivu-table-cell{padding-left:5px;padding-right:5px;overflow:hidden;text-overflow:ellipsis;white-space:normal;word-break:break-all;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
